// extracted by mini-css-extract-plugin
export var toggleContainer = "toggle-module--toggle-container--SFEe4";
export var circle = "toggle-module--circle--HSLyl";